module.exports = __webpack_public_path__ + "static/img/partner.12015597.png";